import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onBlur", "onChange", "onSearch", "onSelect", "value"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { NSuggestInput } from "../NSearchInput";
export var NAutoSuggestInput = function NAutoSuggestInput(_ref) {
  var onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    onSelect = _ref.onSelect,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var firstSuggestRef = useRef(undefined);
  var handleChange = function handleChange() {
    var _firstSuggestRef$curr;
    if (firstSuggestRef.current && value === ((_firstSuggestRef$curr = firstSuggestRef.current) === null || _firstSuggestRef$curr === void 0 ? void 0 : _firstSuggestRef$curr.label)) {
      firstSuggestRef.current = undefined;
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onChange === null || onChange === void 0 || onChange.apply(void 0, args);
  };
  var handleSearch = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
      var results, _results;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onSearch(query);
          case 2:
            results = _context.sent;
            _results = _slicedToArray(results, 1);
            firstSuggestRef.current = _results[0];
            return _context.abrupt("return", results);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onSearch]);
  var handleBlur = function handleBlur() {
    if (firstSuggestRef.current) {
      onSelect === null || onSelect === void 0 || onSelect(firstSuggestRef.current);
    }
  };
  return /*#__PURE__*/React.createElement(NSuggestInput, _extends({
    onBlur: handleBlur,
    onChange: handleChange,
    onSearch: onSearch ? handleSearch : undefined,
    onSelect: onSelect,
    value: value
  }, props, {
    "data-t-id": "components-NAutoSuggestInput"
  }));
};
NAutoSuggestInput.propTypes = process.env.NODE_ENV !== "production" ? {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.string
} : {};